module.exports = __webpack_public_path__ + "static/img/012.d15a3a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-eplus/012.png
// module id = +/6+
// module chunks = 1